import React, { useState, useEffect, useContext } from "react";
import ModalComponent from "../../../../components/Modal";
import { toast } from "react-toastify";
import { EmployeeContext } from "../../../../Context/Employee";
import TextAreaInput from "../../../../components/TextArea";
import { Formik, Form, Field } from "formik";

const BackgroundCheckModal = ({ show, onClose, employeeId, title, notes }) => {
  return (
    <ModalComponent show={show} onClose={onClose} title={title} size="lg">
      <Formik>
        <Form>
          <div className="p-6">
            <TextAreaInput
              name="backgroundCheck"
              value={notes}
              handleChange={() => {}}
              
              Disabled={true}
              rows={12}
              classes="w-full"
                  style={{ minWidth: "100%", maxWidth: "100%" }}
            />
          </div>
        </Form>
      </Formik>
    </ModalComponent>
  );
};

export default BackgroundCheckModal;
